import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Storage from 'react-native-storage';
import i18n from 'i18n-react';
import SweetAlert from 'sweetalert-react';

import { UserInfoProvider } from 'hooks/useUserInfo';
import { SettingsProvider } from 'hooks/useSettings';

// FontAwesome
import 'config/FontAwesome';

import {
  AppSettings,
  APIHandler,
  AppRouter,
  DataHandler,
  locales,
  StorageHandler,
  MobileWarning,
  CookieWarning,
} from 'C4';
import { storageKeys, language, userKeys } from 'settings';

import 'normalize.css/normalize.css';
import './assets/styles/styles.scss';

const { cookieEnabled } = window.navigator;

const exportObject = cookieEnabled
  ? new Storage({
      storageBackend: cookieEnabled ? window.localStorage : {},
      defaultExpires: 1000 * 3600 * 24, // 1 day = (1000 * 3600 * 24 milliseconds), null = never expire
      enableCache: true,
      sync: {
        // TODO: Handle exiration of data (Reload data with new API Calls)
      },
    })
  : {};

export default exportObject;

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load

const availableLanguages = language
  .map(({ code }) => (typeof code === 'string' ? code : code.map((c) => c.toLowerCase())))
  .flat();
const commitRisk = language.some((lang) => lang.id === 220 && lang.countries.length > 0);
if (commitRisk) {
  console.error('One of the testing languages is currently in use. Please remove before committing.');
}

const params = new URLSearchParams(window.location.search);

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => {
          const k = storageKeys[key];
          return k !== storageKeys.appId && k !== storageKeys.lang;
        }),
      );
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang.langFile]);
    });
    if (sessionStorage.getItem(sessionStorage.key('tt_sessionId')) !== '-1') {
      StorageHandler.load(storageKeys.user).then((res) => {
        if (res) {
          const { email } = res;
          APIHandler.lastActive(appId, email);
          sessionStorage.setItem(sessionStorage.key('tt_sessionId'), -1);
        }
      });
    }
  });
  window.appId = appId;
});

if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      StorageHandler.load(storageKeys.lang).then((res) => {
        i18n.setTexts(locales[res.langFile]);
      });

      if (params.get('lang') === 'es') {
        i18n.setTexts(locales.es);
      }
    } else {
      StorageHandler.save(storageKeys.lang, {
        country: 'United States',
        code: 'US',
        langFile: 'en',
      });
      if (params.get('lang')) {
        i18n.setTexts(locales[params.get('lang')]);
        if (params.get('lang') === 'es') {
          StorageHandler.save(storageKeys.lang, {
            country: 'Mexico',
            code: 'ES',
            langFile: params.get('lang'),
          });
        }
      }

      i18n.setTexts(locales.en);
      /* Get user location and check if a language file exists. DISABLED
      APIHandler.getLocation().then((location) => {
        if (params.get("lang")) {
          i18n.setTexts(locales[params.get("lang")]);
          if (params.get("lang") === "es") {
            StorageHandler.save(storageKeys.lang, {
              country: "Mexico",
              code: code,
              langFile: params.get("lang"),
            });
          } else {
            StorageHandler.save(storageKeys.lang, {
              country: "United States",
              code: "US",
              langFile: params.get("lang"),
            });
          }
          window.location.reload();
        } else if (location) {
          const code = location.countryCode.toLowerCase();
          const availableLanguageForUserLocation = (translationFiles) =>
            translationFiles
              .map((translation) => translation === code)
              .includes(true);
          const [file] = language
            .filter(({ code: c }) => c.includes(code))
            .map(({ langFile }) => langFile);

          if (availableLanguageForUserLocation(availableLanguages)) {
            StorageHandler.save(storageKeys.lang, {
              country: location.country.replace(" ", "_"),
              code: code.toLowerCase(),
              langFile: file,
            });
            window.location.reload();
          } else {
            StorageHandler.save(storageKeys.lang, {
              country: location.country.replace(" ", "_"),
              code: location.countryCode.replace(" ", "_"),
              langFile: "en",
            });
            window.location.reload();
          }
        } else {
          StorageHandler.save(storageKeys.lang, {
            country: "United States",
            code: "US",
            langFile: "en",
          });
          i18n.setTexts(locales.en);
          window.location.reload();
        }
      });
      */
    }
  });
  StorageHandler.load('askedMobile').then((askedBefore) => {
    ReactDOM.render(<App askedBefore={askedBefore} />, document.getElementById('root'));
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    const mobileRegex = new RegExp('Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini', 'i');
    const mobilePathRegex = new RegExp('mobile', 'i');
    const mobileParam = new URLSearchParams(window.location.search).get('mobile') === 'true';

    this.state = {
      onMobile: mobileParam
        ? false
        : mobileRegex.test(window.navigator.userAgent) && !mobilePathRegex.test(window.location.href),
      askedBefore: this.props.askedBefore,
      loading: true,
    };
  }

  componentDidMount() {
    this.setLoader();
  }

  setLoader() {
    AppSettings().then((res) => {
      if (res) {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { onMobile, askedBefore, loading } = this.state;
    const params = new URLSearchParams(window.location.search);

    let header = true;
    if (params.get('header') === 'false') {
      header = false;
    }

    if (params.get('mobile') === 'true') {
      header = false;
    }

    if (window.location.pathname === '/register-mobile') {
      header = false;
    }

    if (window.location.pathname === '/register') {
      header = false;
    }

    const setAsked = () => {
      // this.setState({ askedBefore: true });
      // StorageHandler.save('askedMobile', true);
      window.history.back();
    };

    return (
      <SettingsProvider>
        <UserInfoProvider>
          <div className="container__router">
            {!cookieEnabled && <CookieWarning />}
            {loading && (
              <div className="appLoader">
                <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
              </div>
            )}
            {!loading && <AppRouter />}
            {header && onMobile && <MobileWarning />}
          </div>
        </UserInfoProvider>
      </SettingsProvider>
    );
  }
}

App.propTypes = {
  askedBefore: PropTypes.bool.isRequired,
};
